module.exports = __webpack_public_path__ + "img/arrow-up-big.f514718e.svg";